import type { AxiosInstance } from 'axios';
import { Charge } from '@trukt/portal-utils/Charge';
import { BaseRequest } from '@trukt/types/BaseRequest';
import { OrderPartySearchRequest, OrderPartySearchResponse } from './OrderPartyService.types';
import { PartyLiterals } from '@trukt/types/Party';

type OrderPartyRouteParams = { orderGuid: string; partyGuid: string };

export type OrderPartyCreateRequest = BaseRequest<
  void,
  { companyGuid: string; type: PartyLiterals },
  { orderGuid: string }
>;

export type OrderPartyDeleteRequest = BaseRequest<void, void, OrderPartyRouteParams>;

export type OrderPartyChargeSearchRequest = OrderPartyRouteParams;
// this type will be updated to use `Charge` type. This type will come from the vendor payment holds epic
// i don't want to include it now to prevent minimal conflicts
export type OrderPartyChargeSearchResponse = Charge[];

export class OrderPartyService {
  instance: AxiosInstance;

  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  search({ queryParams, routeParams }: OrderPartySearchRequest) {
    return this.instance.get<OrderPartySearchResponse>(`/orders/${routeParams.orderGuid}/parties`, {
      params: queryParams,
    });
  }

  create({ body, routeParams }: OrderPartyCreateRequest) {
    return this.instance.put<void>(`/orders/${routeParams.orderGuid}/parties`, body);
  }

  delete({ routeParams }: OrderPartyDeleteRequest) {
    return this.instance.delete<void>(
      `/orders/${routeParams.orderGuid}/parties/${routeParams.partyGuid}`,
    );
  }

  searchCharges({ orderGuid, partyGuid }: OrderPartyChargeSearchRequest) {
    return this.instance.get<OrderPartyChargeSearchResponse>(
      `/orders/${orderGuid}/parties/${partyGuid}/charges`,
    );
  }
}
